<template>
  <Dialog
    v-model="dialog"
    textBtn="新規登録"
    :width="500"
    closable
    classBtn="ml-2"
    title="活用登録"
  >
    <template v-slot:content>
      <v-row>
        <v-col cols="3">
          <label class="font-weight-medium">
            活用名
            <span class="red--text">*</span>
          </label>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            dense
            outlined
            v-model.trim="name"
            class="pb-0"
            :error-messages="nameErrors"
            @input="$v.name.$touch()"
            @blur="$v.name.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        :disabled="loading"
        color="primary"
        :loading="loading"
        @click="handleCreate"
        >{{ $t("REGISTER") }}</v-btn
      >
      <v-btn class="ml-10" @click="dialog = false">{{ $t("CANCEL") }}</v-btn>
      <v-spacer />
    </template>
  </Dialog>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { createPratice } from "@/api/Pratice.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  components: {
    Dialog,
  },
  mixins: [validationMixin],
  data() {
    return {
      name: "",
      dialog: false,
      loading: false,
    };
  },
  validations() {
    return {
      name: { required },
    };
  },
  watch: {
    dialog: function () {
      this.name = "";
      this.$v.$reset();
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("活用名を入力してください。");
      return errors;
    },
  },
  methods: {
    async handleCreate() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        let params = {
          name: this.name,
        };
        this.loading = true;
        await createPratice(params)
          .then(async () => {
            this.loading = false;
            this.$emit("resetList");
            this.dialog = false;
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>